import { ResourceOptions } from 'react-admin';
import { FaListAlt } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.socialTradingRedpacketDisplayRules;
export const icon = FaListAlt;
export const options: ResourceOptions = {
  label: 'module.socialTrading.redpacketDisplayRules',
};
